module.exports = __webpack_public_path__ + "static/FaktPro-Blond-7699f64b3d25f50aa28eef6520af707b.ttf";